/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {formatNumber, getCurrencySymbol} from '@angular/common';

/**
 *  Formats a numeric value into a currency value, adding the respective currency symbol.
 *  @param value the numeric value to format
 *  @param currencyCode the ISO alphanumeric currency code
 *  @return string the formatted value with the currency code symbol. If the value is null, returns '-'
 */
export function formatWithCurrencySymbol(value: number, currencyCode: string): string {
    let displayValue = '-';

    if (value != null) {
        displayValue = `${formatNumber(value, 'en-US', '1.2-2')} ${currencyCode != null ? getCurrencySymbol(currencyCode, 'narrow') : ''}`;
    }
    return displayValue.trim();
}

